import "./contact.scss";
import {useState} from 'react';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';

export default function Contact(){
    // const [message, setMessage] = useState(false)

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setMessage(true);
    // }
    

    return(
        <div className="contact" id="contact">
            <div className="left">
                <img src="assets/shake.svg" alt="" srcset="" />
            </div>
            <div className="right">
                <h2>Contact Details</h2>
                <br />
                <p>
                    <div>
                        <label htmlFor=""><b>Email : </b></label>
                        <span>chauhan85288@gmail.com</span>
                    </div>

                    <div>
                        <label htmlFor=""><b>Mobile : </b></label>
                        <span>+9183607-04738</span>
                    </div>

                    <div>
                        <label htmlFor=""><b>Location : </b></label>
                        <span>Bangalore (India)</span>
                    </div>

                    <div className="social_icon">
                        <a href="https://www.linkedin.com/in/ravinder-543943110" target="_blank">
                            <LinkedInIcon className="icon linkdin"/>
                        </a>
                        <a href="https://github.com/chauhanravinder" target="_blank">
                            <GitHubIcon className="icon github"/>
                        </a>
                    </div>
                </p>
                {/* <form onSubmit={handleSubmit}>
                    <input type="text" placeholder="Email" />
                    <textarea placeholder="Message"></textarea>
                    <button type="submit">Send</button>
                    {
                        message && <span>Thanks, I wil reply ASAP :)</span>
                    }
                </form> */}
            </div>
        </div>
    );
}